import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ViewObject from './ViewObject';
import {
	getSettings,
	watchSettings,
	unwatchSettings
} from '../utils/eventViewerSettings';
import './ViewEvent.scss';

export default function ViewEvent({
	source = '',
	details,
	diff = null,
	index,
	sourceIndex,
	row = 'auto',
	defaultOpened = false
}) {
	const [highlightDiff, setHighlightDiff] = useState(
		getSettings().cmsWebHighlightDiff
	);
	useEffect(() => {
		const settingsChangeHandler = (newSettings) => {
			if (newSettings.cmsWebHighlightDiff !== highlightDiff) {
				setHighlightDiff(newSettings.cmsWebHighlightDiff);
			}
		};
		watchSettings(settingsChangeHandler);
		return function cleanup() {
			unwatchSettings(settingsChangeHandler);
		};
	});
	const eventIndexClasses = [
		'ws-tagging-ev-event-index',
		'p-2',
		'border-right'
	];
	if (source === 'cms-web' && highlightDiff) {
		if (diff) {
			eventIndexClasses.push('rounded-left bg-danger text-light');
		} else {
			eventIndexClasses.push('rounded-left bg-success text-light');
		}
	}
	return (
		<div
			className={[
				'ws-tagging-ev-event',
				'd-flex',
				'm-4',
				'border',
				'rounded'
			].join(' ')}
			style={{
				gridColumn: sourceIndex + 1,
				gridRow: row
			}}
		>
			<div className={eventIndexClasses.join(' ')}>{index}</div>
			{diff ? (
				<div className="flex-fill">
					<ViewObject
						object={details}
						className="border-bottom"
						defaultOpened={defaultOpened}
					/>
					<ViewObject
						object={diff}
						className="text-danger"
						defaultOpened={defaultOpened}
					/>
				</div>
			) : (
				<ViewObject
					object={details}
					className="flex-fill"
					defaultOpened={defaultOpened}
				/>
			)}
		</div>
	);
}

ViewEvent.propTypes = {
	details: PropTypes.shape({}).isRequired,
	sourceIndex: PropTypes.number.isRequired,
	index: PropTypes.number.isRequired,
	diff: PropTypes.shape({}),
	row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	defaultOpened: PropTypes.bool,
	source: PropTypes.string
};
